import {
    getConfigurableVariant,
    getCategoryPath,
    getCartItemPrice
} from '../functions'
import { MappingItem } from '../../GTM'
import {
    CartItemInterface,
    ConfigurableCartItem,
    ConfigurableProduct,
    ProductInterface
} from '@pylot-data/pylotschema'
import { itemHasKey } from '@corratech/pylot-utils'

const isConfigurableCartItem = (
    item: CartItemInterface
): item is ConfigurableCartItem => {
    return itemHasKey(item, 'configurable_options')
}

const isConfigurableProduct = (
    product: ProductInterface
): product is ConfigurableProduct => {
    return itemHasKey(product, 'variants')
}

const getItemSku = (item: CartItemInterface): string => {
    const product = item?.product
    if (!product) {
        return ''
    }
    if (
        !isConfigurableCartItem(item) ||
        !isConfigurableProduct(product) ||
        !Array.isArray(product?.variants)
    ) {
        return String(product?.sku)
    }
    const selectedOptions: string[] = []
    for (const option of item.configurable_options) {
        if (option?.configurable_product_option_value_uid) {
            selectedOptions.push(option.configurable_product_option_value_uid)
        }
    }
    for (const variant of product.variants) {
        if (!variant?.attributes || !Array.isArray(variant?.attributes)) {
            continue
        }
        let isSelectedVariant = true
        for (const attribute of variant.attributes) {
            if (!attribute?.uid || !selectedOptions.includes(attribute.uid)) {
                isSelectedVariant = false
            }
        }
        if (isSelectedVariant && variant.product?.sku) {
            return variant.product.sku
        }
    }
    return String(product?.sku)
}

const getItemCategoryName = (item: CartItemInterface): string => {
    const product = item?.product
    return product?.categories?.[0]?.name || ''
}

export const cartItemMapping = (
    itemCategoryPath = getCategoryPath,
    cartItemPrice = getCartItemPrice,
    configurableVariant = getConfigurableVariant
): MappingItem => {
    return {
        id: getItemSku,
        name: ['product', 'name'],
        price: cartItemPrice,
        quantity: ['quantity'],
        categoryPath: itemCategoryPath,
        category: getItemCategoryName,
        currencyCode: [
            ['price_range', 'minimum_price', 'final_price', 'currency'],
            ['prices', 'row_total_including_tax', 'currency']
        ],
        variant: configurableVariant,
        brand: ['product', 'brand_name']
    }
}
